// const firebaseConfig = require("../../../firebase.config");

const config = {
  apiKey: "AIzaSyDer1-_D3LdUcIsNugJUTIsI9ZDxL-CKwE",
  authDomain: "medikeep-fd556.firebaseapp.com",
  databaseURL: "https://medikeep-fd556.firebaseio.com",
  projectId: "medikeep-fd556",
  storageBucket: "medikeep-fd556.appspot.com",
  messagingSenderId: "858762695063",
  appId: "1:858762695063:web:c749013fa084f5e540f4d2",
  measurementId: "G-6LQ7WCB3G2",
};

class Firebase {
  constructor(app) {
    if (!app.apps.length) {
      app.initializeApp(config);
    }

    /* Helper */

    this.serverValue = app.database.ServerValue;
    this.emailAuthProvider = app.auth.EmailAuthProvider;

    /* Firebase APIs */

    this.auth = app.auth();
    this.db = app.firestore();
    this.storageRef = app.storage().ref();
    this.appRef = app;

    /* Social Sign In Method Provider */

    this.googleProvider = new app.auth.GoogleAuthProvider();
    this.facebookProvider = new app.auth.FacebookAuthProvider();
    this.twitterProvider = new app.auth.TwitterAuthProvider();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithTwitter = () =>
    this.auth.signInWithPopup(this.twitterProvider);

  doSignOut = () => {
    this.auth.signOut();
    window.location.href = "/";
  };

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      url: process.env.GATSBY_CONFIRMATION_EMAIL_REDIRECT,
    });

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB Users API *** //

  user = uid => this.db.collection("users").doc(uid);

  onAuthUserListener = (next, fallback) =>
    this.auth.onAuthStateChanged(authUser => {
      if (authUser) {
        this.user(authUser.uid)
          .get()
          .then(snapshot => {
            const dbUser = snapshot.data();

            // default empty roles
            if (!dbUser.roles) {
              dbUser.roles = {};
            }

            // merge auth and db users
            authUser = {
              uid: authUser.uid,
              email: authUser.email,
              emailVerified: authUser.emailVerified,
              providerData: authUser.providerData,
              ...dbUser,
            };

            next(authUser);
          });
      } else {
        fallback();
      }
    });
}

let firebase1;

function getFirebase(app, auth, database) {
  if (!firebase1) {
    firebase1 = new Firebase(app, auth, database);
  }

  return firebase1;
}

export default getFirebase;
